export default __webpack_public_path__ + "static/logo-word-b536445bacc406e48cfa137a2f29b60b.png";